<div class="body" [formGroup]="formGroup">

    <mat-toolbar class="ams-toolbar">
        <mat-icon class="main-icon">help</mat-icon>
        <span>
            {{data.title? data.title: 'Aktion abschließen'}}
        </span>
        <span class="spacer"></span>
        <button mat-icon-button (click)="close()" color="warn">
            <mat-icon>close</mat-icon>
        </button>
    </mat-toolbar>

    <div class="content">

        <ng-container *ngIf="data.addNote">

            <div class="note-hint">
                {{data.noteHint? data.noteHint: 'Möchten Sie der Aktion eine Notiz hinzufügen?' }}
            </div>

            <div class="note-wrapper">

                <quill-editor class="quill-note" formControlName="note" [format]="'html'" [modules]="modules"></quill-editor>

            </div>

        </ng-container>

    </div>

    <div class="footer">

        <button mat-raised-button (click)="abort()">
            Abbrechen
        </button>

        <button mat-raised-button color="primary" (click)="close()">
            Abschließen
        </button>

    </div>

</div>